module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('oregon-map', {
    attrs: {
      "mapFile": "or.counties.json",
      "dataFile": "or_load.csv",
      "res": "Lake Owyhee",
      "resFile": "or.json",
      "whichState": "OR"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "OR"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "or.counties.json",
      "centersFile": "or_centers.json",
      "dataFile": "or-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58b819a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Oregon.vue
// module id = 375
// module chunks = 1